// DS: i2.8
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const MoveToFolder: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M19.994 3a1 1 0 011 1L21 20a1 1 0 01-.883.994L20 21H5a1 1 0 01-1-1v-4a1 1 0 01.883-.993L5 15a1 1 0 01.993.883L6 16v3h13V5H6v3a1 1 0 01-.883.993L5 9a1 1 0 01-.993-.883L4 8V4a1 1 0 011-1h14.994zm-6.531 5.339l3.078 3.078a1 1 0 010 1.414l-3.078 3.078a.892.892 0 11-1.262-1.262l1.634-1.634L14 13H4a1 1 0 010-2h9.599l-1.398-1.4a.892.892 0 011.262-1.261z"
      />
    </svg>
  </IconWrap>
);
MoveToFolder.displayName = 'MoveToFolder';

export default MoveToFolder;
